import { intToPx, pxToInt } from '../utilities/helpers.mjs';
import { SPACING_TOKENS } from '../constants/tokens.mjs';

const SPACING_MAX = intToPx(pxToInt(SPACING_TOKENS['space-8']) * 4);
const SIZE_MIN = intToPx(pxToInt(SPACING_TOKENS['space-8']) * 8);
const TOP_PREFERRED_VALUE = '10vh';
const LEFT_PREFERRED_VALUE = '10vw';
const MAX_WIDTH = '60vw';
const MAX_HEIGHT = '60vh';

// NOTE: This layout will be hit immediately upon first render
// (when anchorRect has not yet been measured)
// before re-rendering the `Popover` again with the result
// of all hooks. We will want to make sure this initial
// layout does not cause issues with a entrance animation.
const DEFAULT_POPOVER_LAYOUT = {
  top: `clamp(${SPACING_TOKENS['space-2']}, ${TOP_PREFERRED_VALUE}, ${SPACING_MAX})`,
  left: `clamp(${SPACING_TOKENS['space-2']}, ${LEFT_PREFERRED_VALUE}, ${SPACING_MAX})`,
  maxWidth: `max(${SIZE_MIN}, ${MAX_WIDTH})`,
  maxHeight: `max(${SIZE_MIN}, ${MAX_HEIGHT})`
};

export { DEFAULT_POPOVER_LAYOUT };
